import React from 'react'
import PropTypes from 'prop-types'
import Breadcrumb from '../Breadcrumb'
import TitleImage from '../TitleImage'
import { renderable } from '../../../common/propTypes'

const NewsRoomPageLayout = ({ children, category, title }) => {
  const header = category?.title
    ? [
        { label: 'Home', path: '/' },
        { label: category?.title, path: `/${category?.slug}/` },
        { label: title, path: '' },
      ]
    : [
        { label: 'Home', path: '/' },
        { label: title, path: '' },
      ]

  return (
    <div
      className="mx-auto mb-16 mt-2 max-w-screen-lg border-t border-gray-190 md:mt-0 md:px-3 xl:px-0"
      data-testid="newsroom-layout"
    >
      <div className="px-5 py-4 md:px-2 md:py-5 lg:px-0">
        <Breadcrumb items={header} />
      </div>
      <TitleImage img="/next-assets/news-1000x200.webp" text="Newsroom" />
      <main>{children}</main>
    </div>
  )
}

NewsRoomPageLayout.defaultProps = {
  category: {},
}

NewsRoomPageLayout.propTypes = {
  category: PropTypes.object,
  title: PropTypes.string.isRequired,
  children: renderable.isRequired,
}

export default NewsRoomPageLayout
